export const keys = [
  'question_title_missing',
  'question_talk_track_script_missing',
  'question_talk_track_script_too_long',
  'question_moderation_task_missing',
  'question_moderation_task_too_long',
  'question_tutor_bot_script_missing',
  'question_tutor_bot_script_too_long',
  'question_moderator_bot_script_missing',
  'question_moderator_bot_script_too_long',
  'question_grader_bot_script_missing',
  'question_grader_bot_script_too_long',
  'question_role_play_bot_script_missing',
  'question_role_play_bot_script_too_long',
  'question_poll_missing',
  'question_poll_too_long',
  'question_custom_poll_missing',
  'question_custom_poll_too_long',
  'question_custom_poll_no_answers',
  'question_sorting_missing',
  'question_sorting_too_long',
  'question_sorting_no_answers',
  'question_sortable_string_list_missing',
  'question_sortable_string_list_too_long',
  'question_sortable_string_list_min_length_missing',
  'question_sortable_string_list_min_length_invalid',
  'question_sortable_string_list_min_length_not_integer',
  'question_sortable_string_list_min_length_exceeds_max_allowed',
  'question_sortable_string_list_max_length_missing',
  'question_sortable_string_list_max_length_invalid',
  'question_sortable_string_list_max_length_not_integer',
  'question_sortable_string_list_max_length_exceeds_max_allowed',
  'question_sortable_string_list_min_greater_than_max',
  'question_pop_up_instructions_title_missing',
  'question_pop_up_instructions_content_missing',
  'question_pop_up_instructions_icon_missing',
  'question_pop_up_instructions_button_label_missing',
  'question_multiple_choice_missing',
  'question_multiple_choice_too_long',
  'question_multiple_choice_no_answers',
  'question_multiple_choice_correct_invalid',
  'question_slide_mismatch',
] as const

export type SlideQuestionErrorKey = (typeof keys)[number]

export const SlideQuestionErrorKeys = Object.fromEntries(
  keys.map((key) => [key, key])
) as { [K in SlideQuestionErrorKey]: K }
